import { ReactNode } from 'react'

type Props = {
  isSelf?: boolean
  children?: ReactNode
}

const spLayoutClassName = `
grid-cols-3 gap-x-3 gap-y-[10px]
[&>li:not(:nth-child(12n+1)):not(:nth-child(12n-4))>*:first-child]:aspect-[5/6] 
[&>li:nth-child(12n+1)]:col-span-2 
[&>li:nth-child(12n+1)]:row-span-2 
[&>li:nth-child(12n-4)]:col-span-2 
[&>li:nth-child(12n-4)]:row-span-2 
`

const pcLayoutClassName = `
xl:grid-cols-6 xl:gap-x-[18px] xl:gap-y-3 
xl:[&>li:not(:nth-child(24n+1)):not(:nth-child(24n+3)):not(:nth-child(24n-10)):not(:nth-child(24n-8))>*:first-child]:aspect-[5/6] 
xl:[&>li:nth-child(24n+1)]:col-span-2 
xl:[&>li:nth-child(24n+1)]:row-span-2 
xl:[&>li:nth-child(24n+3)]:col-span-2 
xl:[&>li:nth-child(24n+3)]:row-span-2 
xl:[&>li:nth-child(24n-10)]:col-span-2 
xl:[&>li:nth-child(24n-10)]:row-span-2 
xl:[&>li:nth-child(24n-8)]:col-span-2 
xl:[&>li:nth-child(24n-8)]:row-span-2
`

const resetSpLayoutClassName = `
xl:[&>li:nth-child(12n+1)]:col-span-1 
xl:[&>li:nth-child(12n+1)]:row-span-1 
xl:[&>li:nth-child(12n-4)]:col-span-1 
xl:[&>li:nth-child(12n-4)]:row-span-1
`

export const FolderElementList: React.FC<Props> = ({
  children,
  isSelf = false,
}) =>
  isSelf ? (
    <ul className="grid grid-cols-3 gap-x-3 gap-y-[10px] [&>li>*:first-child]:aspect-[3/4]">
      {children}
    </ul>
  ) : (
    <ul
      className={`grid ${spLayoutClassName} ${pcLayoutClassName} ${resetSpLayoutClassName}`}
    >
      {children}
    </ul>
  )
